
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.44 1h3.12v5.75h2.438a.5.5 0 01.355.852L16 12l-4.353-4.398a.5.5 0 01.355-.852h2.438V1zm1.518 17.94v11.158l8.53-1.686v-5.436c0-.228.19-.405.407-.379l1.05.17a.376.376 0 01.324.378v6.315c0 .18-.12.335-.29.373l-9.336 2.09a3.163 3.163 0 01-1.37.004l-9.237-2.024a.377.377 0 01-.29-.363l-.16-6.414a.376.376 0 01.334-.389l7.846-.718a.368.368 0 00.306-.234l1.182-2.99c.153-.386.704-.272.704.145zm-10.46-3.653l-2.463 5.481c-.12.268.086.57.368.54l9.247-.973c.13-.013.244-.099.298-.224l2.975-6.98-10.16 1.943a.368.368 0 00-.266.213zm10.425-2.157l3.148 7.2c.055.125.171.21.304.22l9.23.774c.278.023.477-.274.361-.538l-2.407-5.495a.368.368 0 00-.268-.217L15.923 13.13z"}})])
          )
        }
      }
    